export const Tier4ActiveCollectibles = [
    ['The D6', '105'],
    ['Satanic Bible', '292'],
    ['Mega Blast', '441'],
    ['Void', '477'],
    ['D Infinity', '489'],
    ['Broken Shovel', '550'],
    ['Mom\'s Shovel', '552'],
    ['Mega Mush', '625'],
    ['Death Certificate', '628'],
    ['R Key', '636'],
    ['Abyss', '706'],
    ['Bag of Crafting', '710'],
    ['Flip', '711'],
    ['Spindown Dice', '723'],
];